import {Injectable} from "@angular/core";
import {CreateListUseCase} from "@app/core/lists/application/create-list.use-case";
import {RenameListUseCase} from "@app/core/lists/application/rename-list.use-case";
import {Observable, switchMap} from "rxjs";
import {List} from "@app/core/lists/domain/list";
import {onError} from "@app/presentation/rxjs-utils/operators/on-error";
import {PopupNotifier} from "@app/presentation/components/errors/popup.notifier";
import {createStatusStore} from "@app/presentation/rxjs-utils/create-status-store";
import {onIsLoadingChanges} from "@app/presentation/rxjs-utils/operators/on-is-loading-changes";
import {take} from "rxjs/operators";
import {RecaptchaAction, RecaptchaService} from "@app/presentation/services/recaptcha/recaptcha.service";

@Injectable({
    providedIn: 'root'
})
export class CreateListViewModel {

    notifier = new PopupNotifier();

    private requestStatus = createStatusStore();
    readonly isRequestLoading$ = this.requestStatus.isLoading$;

    constructor(
        private createListUseCase: CreateListUseCase,
        private renameListUseCase: RenameListUseCase,
        private recaptchaService: RecaptchaService,
    ) {
    }

    createList(name: string, productsCodes: string[]): Observable<List> {

        return this.recaptchaService.getToken(RecaptchaAction.CREATE_LIST).pipe(
            switchMap(recaptchaToken =>
                this.createListUseCase.execute(name, recaptchaToken, productsCodes).pipe(
                    take(1),
                    onIsLoadingChanges(this.requestStatus.setIsLoading),
                    onError(error => this.notifier.notifyError(error)),
                )
            ),
        );
    }

    renameList(listId: number, newName: string): Observable<List> {
        return this.renameListUseCase.execute(listId, newName).pipe(
            take(1),
            onIsLoadingChanges(this.requestStatus.setIsLoading),
            onError(error => this.notifier.notifyError(error))
        )
    }
}
